/*
 * Copyright 2020-2021 AskChristee, LLC. All rights reserved.
 */

import React from 'react';

import { TBuyerQualChoiceResponseObjectV2 } from '../../../../types/api';
import { BrowMess, DetailCashNaked, DetailPercent, DetailText, DetailTextCenter, HtmlDetailTextTwo, TdDownloadPdf } from '../../../atoms';

interface Props {
  conventional: TBuyerQualChoiceResponseObjectV2;
  fha: TBuyerQualChoiceResponseObjectV2;
  va: TBuyerQualChoiceResponseObjectV2;
  usda: TBuyerQualChoiceResponseObjectV2;
}

const BuyerChoiceCash = ({ conventional, fha, va, usda }: Props) => {
  if (conventional.bCalc) {
    var aText = conventional.bCalc.brow_head;
  } else {
    var aText = '';
  }
  if (fha.bCalc) {
    var bText = fha.bCalc.brow_head;
  } else {
    var bText = '';
  }
  if (va.bCalc) {
    var cText = va.bCalc.brow_head;
  } else {
    var cText = '';
  }
  if (usda.bCalc) {
    var dText = usda.bCalc.brow_head;
  } else {
    var dText = '';
  }

  return (
    <table className="table">
      <tbody>
        <tr>
          <td colSpan={5}>
            <BrowMess a={aText} b={bText} c={cText} d={dText} />
          </td>
        </tr>
        <tr>
          <DetailText v="Loan Type" />
          {conventional?.bCalc ? <DetailTextCenter v={conventional.bCalc.report_type} /> : null}
          {fha?.bCalc ? <DetailTextCenter v={fha.bCalc.report_type} /> : null}
          {va?.bCalc ? <DetailTextCenter v={va.bCalc.report_type} /> : null}
          {usda?.bCalc ? <DetailTextCenter v={usda.bCalc.report_type} /> : null}
        </tr>
        <tr>
          <DetailText v="Alerts" />
          {conventional?.bCalc ? <DetailTextCenter v={conventional?.bCalc?.fumess} /> : null}
          {fha?.bCalc ? <DetailTextCenter v={fha?.bCalc?.fumess} /> : null}
          {va?.bCalc ? <DetailTextCenter v={va?.bCalc?.fumess} /> : null}
          {usda?.bCalc ? <DetailTextCenter v={usda?.bCalc?.fumess} /> : null}
        </tr>
        <tr>
          <DetailText v="Target Monthly Payment" />
          {conventional?.bCalc ? <DetailCashNaked v={conventional?.bCalc?.target_piti} /> : null}
          {fha?.bCalc ? <DetailCashNaked v={fha?.bCalc?.target_piti} /> : null}
          {va?.bCalc ? <DetailCashNaked v={va?.bCalc?.target_piti} /> : null}
          {usda?.bCalc ? <DetailCashNaked v={usda?.bCalc?.target_piti} /> : null}
        </tr>
        <tr className="active-row">
          <DetailText v="Purchase Price" />
          {conventional?.bCalc ? <DetailCashNaked v={conventional?.bCalc?.sp} /> : null}
          {fha?.bCalc ? <DetailCashNaked v={fha?.bCalc?.sp} /> : null}
          {va?.bCalc ? <DetailCashNaked v={va?.bCalc?.sp} /> : null}
          {usda?.bCalc ? <DetailCashNaked v={usda?.bCalc?.sp} /> : null}
        </tr>
        <tr className="active-row">
          <DetailText v="Base Loan Amount" />
          {conventional?.bCalc ? <HtmlDetailTextTwo a={conventional?.bCalc?.ma} b={conventional?.bCalc?.ltv} /> : null}
          {fha?.bCalc ? <HtmlDetailTextTwo a={fha?.bCalc?.ma} b={fha?.bCalc?.ltv} /> : null}
          {va?.bCalc ? <HtmlDetailTextTwo a={va?.bCalc?.ma} b={va?.bCalc?.ltv} /> : null}
          {usda?.bCalc ? <HtmlDetailTextTwo a={usda?.bCalc?.ma} b={usda?.bCalc?.ltv} /> : null}
        </tr>
        <tr>
          <DetailText v="Total Loan Amount" />
          {conventional?.bCalc ? <DetailCashNaked v={conventional?.bCalc?.total_mtge} /> : null}
          {fha?.bCalc ? <DetailCashNaked v={fha?.bCalc?.total_mtge} /> : null}
          {va?.bCalc ? <DetailCashNaked v={va?.bCalc?.total_mtge} /> : null}
          {usda?.bCalc ? <DetailCashNaked v={usda?.bCalc?.total_mtge} /> : null}
        </tr>
        <tr>
          <DetailText v="Down Payment" />
          {conventional?.bCalc ? <HtmlDetailTextTwo a={conventional?.bCalc?.d_payment} b={conventional?.bCalc?.pdf_dp} /> : null}
          {fha?.bCalc ? <HtmlDetailTextTwo a={fha?.bCalc?.d_payment} b={fha?.bCalc?.pdf_dp} /> : null}
          {va?.bCalc ? <HtmlDetailTextTwo a={va?.bCalc?.d_payment} b={va?.bCalc?.pdf_dp} /> : null}
          {usda?.bCalc ? <HtmlDetailTextTwo a={usda?.bCalc?.d_payment} b={usda?.bCalc?.pdf_dp} /> : null}
        </tr>
        <tr>
          <DetailText v="Closing Cost" />
          {conventional?.bCalc ? <DetailCashNaked v={conventional?.bCalc?.totalcc} /> : null}
          {fha?.bCalc ? <DetailCashNaked v={fha?.bCalc?.totalcc} /> : null}
          {va?.bCalc ? <DetailCashNaked v={va?.bCalc?.totalcc} /> : null}
          {usda?.bCalc ? <DetailCashNaked v={usda?.bCalc?.totalcc} /> : null}
        </tr>
        <tr>
          <DetailText v="Seller Credit" />
          {conventional?.bCalc ? <HtmlDetailTextTwo a={conventional.bCalc.dol_cred} b={conventional.bCalc.temp_cred} /> : null}
          {fha?.bCalc ? <HtmlDetailTextTwo a={fha.bCalc.dol_cred} b={fha.bCalc.temp_cred} /> : null}
          {va?.bCalc ? <HtmlDetailTextTwo a={va.bCalc.dol_cred} b={va.bCalc.temp_cred} /> : null}
          {usda?.bCalc ? <HtmlDetailTextTwo a={usda.bCalc.dol_cred} b={usda.bCalc.temp_cred} /> : null}
        </tr>
        <tr>
          <DetailText v="Lender Credit" />
          {conventional?.bCalc ? <HtmlDetailTextTwo a={conventional?.bCalc?.dol_lend} b={conventional?.bCalc?.temp_lend} /> : null}
          {fha?.bCalc ? <HtmlDetailTextTwo a={fha?.bCalc?.dol_lend} b={fha?.bCalc?.temp_lend} /> : null}
          {va?.bCalc ? <HtmlDetailTextTwo a={va?.bCalc?.dol_lend} b={va?.bCalc?.temp_lend} /> : null}
          {usda?.bCalc ? <HtmlDetailTextTwo a={usda?.bCalc?.dol_lend} b={usda?.bCalc?.temp_lend} /> : null}
        </tr>
        <tr className="active-row">
          <DetailText v="Required Cash" />
          {conventional?.bCalc ? <DetailCashNaked v={conventional?.bCalc?.r_cash} /> : null}
          {fha?.bCalc ? <DetailCashNaked v={fha?.bCalc?.r_cash} /> : null}
          {va?.bCalc ? <DetailCashNaked v={va?.bCalc?.r_cash} /> : null}
          {usda?.bCalc ? <DetailCashNaked v={usda?.bCalc?.r_cash} /> : null}
        </tr>
        <tr>
          <DetailText v="Cash available" />
          {conventional?.bCalc ? <DetailCashNaked v={conventional?.bCalc?.t_cash} /> : null}
          {fha?.bCalc ? <DetailCashNaked v={fha?.bCalc?.t_cash} /> : null}
          {va?.bCalc ? <DetailCashNaked v={va?.bCalc?.t_cash} /> : null}
          {usda?.bCalc ? <DetailCashNaked v={usda?.bCalc?.t_cash} /> : null}
        </tr>
        <tr>
          <DetailText v="Additional Cash Required" />
          {conventional?.bCalc ? <DetailCashNaked v={conventional?.bCalc?.ex_cash} /> : null}
          {fha?.bCalc ? <DetailCashNaked v={fha?.bCalc?.ex_cash} /> : null}
          {va?.bCalc ? <DetailCashNaked v={va?.bCalc?.ex_cash} /> : null}
          {usda?.bCalc ? <DetailCashNaked v={usda?.bCalc?.ex_cash} /> : null}
        </tr>
        <tr>
          <DetailText v="Interest Rate" />
          {conventional.bCalc && <DetailTextCenter v={conventional.bCalc.rate_display.toString()} />}
          {fha.bCalc && <DetailTextCenter v={fha.bCalc.rate_display.toString()} />}
          {va.bCalc && <DetailTextCenter v={va.bCalc.rate_display.toString()} />}
          {usda.bCalc && <DetailTextCenter v={usda.bCalc.rate_display.toString()} />}
        </tr>
        <tr className="active-row">
          <DetailText v="Total Monthly Payment" />
          {conventional?.bCalc ? <DetailCashNaked v={conventional?.bCalc?.t_piti} /> : null}
          {fha?.bCalc ? <DetailCashNaked v={fha?.bCalc?.t_piti} /> : null}
          {va?.bCalc ? <DetailCashNaked v={va?.bCalc?.t_piti} /> : null}
          {usda?.bCalc ? <DetailCashNaked v={usda?.bCalc?.t_piti} /> : null}
        </tr>
        <tr>
          <DetailText v="Principal &amp; Interest" />
          {conventional.bCalc && <HtmlDetailTextTwo a={conventional.bCalc.temp_pi.toString()} b={conventional.bCalc.res_pi.toString()} />}
          {fha.bCalc && <HtmlDetailTextTwo a={fha.bCalc.temp_pi.toString()} b={fha.bCalc.res_pi.toString()} />}
          {va.bCalc && <HtmlDetailTextTwo a={va.bCalc.temp_pi.toString()} b={va.bCalc.res_pi.toString()} />}
          {usda.bCalc && <HtmlDetailTextTwo a={usda.bCalc.temp_pi.toString()} b={usda.bCalc.res_pi.toString()} />}
        </tr>
        <tr>
          <DetailText v="Monthly Mortgage Insurance" />
          {conventional?.bCalc ? <HtmlDetailTextTwo a={conventional?.bCalc.temp_mi} b={conventional?.bCalc.res_mi} /> : null}
          {fha?.bCalc ? <HtmlDetailTextTwo a={fha?.bCalc.temp_mi} b={fha?.bCalc.res_mi} /> : null}
          {va?.bCalc ? <HtmlDetailTextTwo a={va?.bCalc.temp_mi} b={va?.bCalc.res_mi} /> : null}
          {usda?.bCalc ? <HtmlDetailTextTwo a={usda?.bCalc.temp_mi} b={usda?.bCalc.res_mi} /> : null}
        </tr>
        <tr>
          <DetailText v="Monthly Property Taxes" />
          {conventional?.bCalc ? <HtmlDetailTextTwo a={conventional?.bCalc.temp_pt} b={conventional?.bCalc.res_pt} /> : null}
          {fha?.bCalc ? <HtmlDetailTextTwo a={fha?.bCalc.temp_pt} b={fha?.bCalc.res_pt} /> : null}
          {va?.bCalc ? <HtmlDetailTextTwo a={va?.bCalc.temp_pt} b={va?.bCalc.res_pt} /> : null}
          {usda?.bCalc ? <HtmlDetailTextTwo a={usda?.bCalc.temp_pt} b={usda?.bCalc.res_pt} /> : null}
        </tr>
        <tr>
          <DetailText v="Monthly Property Insurance" />
          {conventional?.bCalc ? <HtmlDetailTextTwo a={conventional?.bCalc.temp_ins} b={conventional?.bCalc.res_ins} /> : null}
          {fha?.bCalc ? <HtmlDetailTextTwo a={fha?.bCalc.temp_ins} b={fha?.bCalc.res_ins} /> : null}
          {va?.bCalc ? <HtmlDetailTextTwo a={va?.bCalc.temp_ins} b={va?.bCalc.res_ins} /> : null}
          {usda?.bCalc ? <HtmlDetailTextTwo a={usda?.bCalc.temp_ins} b={usda?.bCalc.res_ins} /> : null}
        </tr>
        <tr>
          <DetailText v="Monthly Condo/HOA fee" />
          {conventional?.bCalc ? <HtmlDetailTextTwo a={conventional?.bCalc.condo} b={conventional?.bCalc.res_condo} /> : null}
          {fha?.bCalc ? <HtmlDetailTextTwo a={fha?.bCalc.condo} b={fha?.bCalc.res_condo} /> : null}
          {va?.bCalc ? <HtmlDetailTextTwo a={va?.bCalc.condo} b={va?.bCalc.res_condo} /> : null}
          {usda?.bCalc ? <HtmlDetailTextTwo a={usda?.bCalc.condo} b={usda?.bCalc.res_condo} /> : null}
        </tr>
        <tr>
          <DetailText v="Estimated Annual Tax Deduction" />
          {conventional?.bCalc ? <DetailCashNaked v={conventional?.bCalc?.tot_duct} /> : null}
          {fha?.bCalc ? <DetailCashNaked v={fha?.bCalc?.tot_duct} /> : null}
          {va?.bCalc ? <DetailCashNaked v={va?.bCalc?.tot_duct} /> : null}
          {usda?.bCalc ? <DetailCashNaked v={usda?.bCalc?.tot_duct} /> : null}
        </tr>
        <tr>
          <DetailText v="Net Monthly Mortgage Payment" />
          {conventional?.bCalc ? <DetailCashNaked v={conventional?.bCalc?.net_mort_pay} /> : null}
          {fha?.bCalc ? <DetailCashNaked v={fha?.bCalc?.net_mort_pay} /> : null}
          {va?.bCalc ? <DetailCashNaked v={va?.bCalc?.net_mort_pay} /> : null}
          {usda?.bCalc ? <DetailCashNaked v={usda?.bCalc?.net_mort_pay} /> : null}
        </tr>
        <tr>
          <DetailText v="Debt Ratio" />
          {conventional?.bCalc ? <DetailPercent v={conventional?.bCalc?.cal_br} /> : null}
          {fha?.bCalc ? <DetailPercent v={fha?.bCalc?.cal_br} /> : null}
          {va?.bCalc ? <DetailPercent v={va?.bCalc?.cal_br} /> : null}
          {usda?.bCalc ? <DetailPercent v={usda?.bCalc?.cal_br} /> : null}
        </tr>
        <tr>
          <TdDownloadPdf />
        </tr>
      </tbody>
    </table>
  );
};

export default BuyerChoiceCash;
